<template>
  <div class="head-box">

    <div class="web-tit">
      <div class="w1200 dis">
        <div> <span class="web-tit-r">买卖木材就上聚木网</span> <span class="web-tit-l">聚木网欢迎您</span></div>
        <div>咨询电话：180-8672-7328</div>
      </div>
    </div>
    <div :class="['bgfff p39',logotop?'p39-shadow':'']">
      <div class="w1200  opflex">
        <el-image src="/static/imgs/logo.png" fit="cover" class="fl logohw cupo" @click="goindex" />
        <div class="over dis mt5 fl">
          <div class="input-box dis">
            <div class="sele-box">
              <el-dropdown class="lin32 cupo" trigger="hover" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{gqTitle}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in datms.gqTap" :command="item.val"
                    :key="index">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <input v-model="input" :placeholder="'请输入您想要的' + gqTitle" class="inp-bor" maxlength="50" />
          </div>
          <div class="input-btn cupo" @click="search">搜索</div>
        </div>
        <div class="fl wx-imgs">
          <el-image src="/static/imgs/wximg.png" fit="cover" class="img-opwx" />
          <span class="img-txt">扫码进入小程序</span>
        </div>
      </div>
    </div>


    <div class="nav-box">
      <div class="nav-box-list dis">
        <div v-for="(item,index) in datms.nav" :class="['linkbox',index==datms.nav.length-1 ?'nobor':'bor']"
          :key="index">
          <router-link :class="['nav-a ']" :to="item.path" active-class="active-link" >{{item.name}}
            <div class="acty">
            </div>
          </router-link>
        </div>
      </div>
    </div>





  </div>
</template>

<script>
  export default {
    data() {
      return {
        gqTitle: '',
        input: '',
        type: 0,
        logotop: false
      }
    },
    mounted() {
      window.addEventListener("scroll", this.updateScrollPosition);
      this.gqTitle = this.datms.gqTap[0].name
      if (JSON.stringify(this.$store.state.searValue) !== '{}' && this.$store.state.searValue.val) {
        this.input = this.$store.state.searValue.val
      }


    },
    methods: {
      updateScrollPosition() {
        this.logotop = window.scrollY >= 225 ? true : false
      },
      handleCommand(command) {
        this.type = command
        this.gqTitle = this.datms.gqTap.find((item) => item.val == command).name
      },
      goindex() {
        let pa = '/index'
        if (this.$route.path !== pa) {
          this.$router.push({
            path: pa
          })
        }
      },


      search() {
        this.$store.commit('searValue', {
          type: this.type,
          val: this.input,
          classify: 0,
          page: 1
        });
        this.$router.push({
          path: '/demand',
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });

      }
    }
  }
</script>

<style scoped>
  @import url('../../static/css/head.css');
</style>



// WEBPACK FOOTER //
// src/components/heads.vue